<template>
    <app-content class="h-panel">
        <div class="h-panel-bar">
            <span class="h-panel-title">日记账</span>
        </div>
        <div class="margin-top margin-left filter-bar">
            <Tabs :datas="tabDatas" v-model="tab" @change="onTabChange" class-name="h-tabs-card"></Tabs>
            <span class="label">账户：</span>
            <Select v-model="accountId" :datas="accountOptions" keyName="id" titleName="name"
                    :deletable="false" style="width:200px" @change="loadList"></Select>
            <DatePicker v-model="p1" type="month" format="yyyy-MM"></DatePicker>
            <span class="label">至</span>
            <DatePicker v-model="p2" type="month" format="yyyy-MM"></DatePicker>
            <Button size="s" @click="loadList">刷新</Button>
            <Checkbox v-model="showAllCols">显示全部列</Checkbox>
            <span class="flex-spacer"></span>
            <Button color="primary" size="s" @click="add">记账</Button>
            <Button size="s" :disabled="!checkedList.length" @click="generateVoucher">生成凭证</Button>
            <Button size="s" :disabled="!checkedList.length" @click="batchRemove">批量操作</Button>
            <Button size="s" @click="exportCsv">导出</Button>
            <Button size="s" @click="printPage">打印</Button>
            <Button size="s" @click="showImport = true">导入</Button>
        </div>
        <div class="h-panel-body">
            <table class="grid">
                <thead>
                <tr>
                    <th style="width:44px"><input type="checkbox" :checked="checkAll" @click="toggleAll"></th>
                    <th style="width:70px">日记账序号</th>
                    <th style="width:100px">日期</th>
                    <th style="width:80px">币别</th>
                    <th style="min-width:150px">摘要</th>
                    <th style="width:120px">收支类别</th>
                    <th style="width:120px">收入(借方)</th>
                    <th style="width:120px">支出(贷方)</th>
                    <th style="width:130px">余额</th>
                    <th v-if="showAllCols" style="width:120px">对方户名</th>
                    <th v-if="showAllCols" style="width:180px">对方科目</th>
                    <th v-if="showAllCols" style="width:110px">单据号</th>
                    <th v-if="showAllCols" style="min-width:120px">备注</th>
                    <th style="width:100px">关联凭证</th>
                    <th style="width:110px">操作</th>
                </tr>
                </thead>
                <tbody>
                <tr class="init-row">
                    <td :colspan="5" align="center">初始余额</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td align="right">{{initBalance|numFormat}}</td>
                    <td v-if="showAllCols"></td>
                    <td v-if="showAllCols"></td>
                    <td v-if="showAllCols"></td>
                    <td v-if="showAllCols"></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr v-for="item in datas" :key="item.id">
                    <td align="center"><input type="checkbox" v-model="item._checked" :disabled="!!item.voucherId"></td>
                    <td align="center">{{item.seq}}</td>
                    <td>{{item.journalDate}}</td>
                    <td>{{item.currencyName}}</td>
                    <td>{{item.summary}}</td>
                    <td>{{item.ioTypeName}}</td>
                    <td align="right">{{item.direction === 1 ? (item.amount|numFormat) : ''}}</td>
                    <td align="right">{{item.direction === 2 ? (item.amount|numFormat) : ''}}</td>
                    <td align="right">{{item.balance|numFormat}}</td>
                    <td v-if="showAllCols">{{item.counterparty}}</td>
                    <td v-if="showAllCols">{{item.subjectCode}} {{item.subjectName}}</td>
                    <td v-if="showAllCols">{{item.billNo}}</td>
                    <td v-if="showAllCols">{{item.remark}}</td>
                    <td class="text-hover">{{item.voucherWord}}{{item.voucherCode || ''}}</td>
                    <td class="actions">
                        <span @click="edit(item)">编辑</span>
                        <span @click="remove(item)">删除</span>
                    </td>
                </tr>
                <tr v-if="!datas.length">
                    <td :colspan="colCount" class="text-center padding">暂无数据</td>
                </tr>
                <tr class="total">
                    <td :colspan="5" align="center">合计金额</td>
                    <td></td>
                    <td align="right">{{totalIncome|numFormat}}</td>
                    <td align="right">{{totalExpense|numFormat}}</td>
                    <td align="right">{{endBalance|numFormat}}</td>
                    <td v-if="showAllCols"></td>
                    <td v-if="showAllCols"></td>
                    <td v-if="showAllCols"></td>
                    <td v-if="showAllCols"></td>
                    <td></td>
                    <td></td>
                </tr>
                </tbody>
            </table>
        </div>

        <!-- 记账 -->
        <Modal v-model="showForm" type="drawer-right" hasCloseIcon>
            <div slot="header">{{form.id ? '编辑' : (currentAccountName || '日记账')}}日记账</div>
            <Form ref="form" v-width="450" :labelWidth="100" :model="form" :rules="validationRules">
                <FormItem label="摘要"><input type="text" v-model="form.summary" @blur="matchIoType"></FormItem>
                <FormItem label="记账账户" prop="accountId">
                    <Select v-model="form.accountId" :datas="allAccountOptions" keyName="id" titleName="name"
                            :deletable="false"></Select>
                </FormItem>
                <FormItem label="记账日期" prop="journalDate">
                    <DatePicker v-model="form.journalDate" format="yyyy-MM-dd"></DatePicker>
                </FormItem>
                <FormItem label="收支类别">
                    <Select v-model="form.ioTypeId" :datas="ioTypeOptions" keyName="id" titleName="name"
                            :deletable="false" @change="onIoTypeChange"></Select>
                </FormItem>
                <FormItem label="金额" prop="amount">
                    <NumberInput v-model="form.amount" :precision="2" :min="0"></NumberInput>
                </FormItem>
                <FormItem label="对方科目">
                    <Select v-model="form.subjectId" :datas="subjectOptions" keyName="id" titleName="name"
                            :deletable="false"></Select>
                </FormItem>
                <FormItem label="对方户名"><input type="text" v-model="form.counterparty"></FormItem>
                <FormItem label="单据号"><input type="text" v-model="form.billNo"></FormItem>
                <FormItem label="备注"><textarea rows="2" v-model="form.remark"></textarea></FormItem>
            </Form>
            <div class="text-center margin-top">
                <Button color="green" @click="submit(false)" :loading="loading">保存</Button>
                <Button color="primary" @click="submit(true)" :loading="loading" v-if="!form.id">保存并新增</Button>
                <Button @click="showForm=false">取消</Button>
            </div>
        </Modal>
        <import-modal v-model="showImport" title="日记账导入" templateUrl="/api/cashier-journal/template" :import-fn="importJournal" @success="loadList"></import-modal>
    </app-content>
</template>

<script>
import ImportModal from '../../components/common/ImportModal';

const emptyForm = {
    id: null, summary: '', accountId: null, journalDate: new Date(), ioTypeId: null,
    amount: 0, subjectId: null, counterparty: '', billNo: '', remark: '', direction: 1
};

export default {
    name: 'CashierJournal',
    components: { ImportModal },
    data() {
        const now = new Date();
        const ym = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
        return {
            datas: [],
            showImport: false,
            tab: 'bank',
            tabDatas: { bank: '银行日记账', cash: '现金日记账' },
            accountId: null,
            accountOptions: [],
            allAccounts: [],
            p1: ym,
            p2: ym,
            showAllCols: true,
            initBalance: 0,
            totalIncome: 0,
            totalExpense: 0,
            showForm: false,
            loading: false,
            form: Object.assign({}, emptyForm),
            subjectOptions: [],
            ioTypeOptions: [],
            validationRules: { required: ['accountId', 'journalDate', 'amount'] }
        };
    },
    computed: {
        allAccountOptions() {
            return [{ id: null, name: '请选择' }].concat(this.allAccounts);
        },
        currentAccountName() {
            const a = this.allAccounts.find(a => a.id === this.form.accountId);
            return a ? a.name : '';
        },
        checkAll() {
            return this.datas.length > 0 && this.datas.every(d => d._checked);
        },
        checkedList() {
            return this.datas.filter(d => d._checked);
        },
        colCount() {
            return this.showAllCols ? 15 : 11;
        },
        endBalance() {
            return Number(this.initBalance || 0) + Number(this.totalIncome || 0) - Number(this.totalExpense || 0);
        }
    },
    watch: {
        showForm(val) { if (!val) this.form = Object.assign({}, emptyForm); }
    },
    methods: {
        importJournal(fd) {
            return this.$api.funds.journal.importData(fd);
        },
        fmtPeriod(d) {
            if (!d) return '';
            if (typeof d === 'string') return d;
            return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
        },
        fmtDate(d) {
            if (!d) return '';
            if (typeof d === 'string') return d;
            return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
        },
        loadOptions() {
            this.$api.funds.journal.options().then(({ data }) => {
                this.allAccounts = data.accounts || [];
                const ios = data.ioTypes || [];
                this.ioTypeOptions = [{ id: null, name: '请选择' }].concat(ios);
                this.subjectOptions = [{ id: null, name: '请选择' }].concat(
                    (data.subjects || []).map(s => ({ id: s.id, name: s.code ? `${s.code} ${s.name}` : s.name })));
                this.buildAccountOptions();
                if (this.accountId == null && this.accountOptions.length > 1) {
                    this.accountId = this.accountOptions[1].id;
                }
                this.loadList();
            });
        },
        buildAccountOptions() {
            const type = this.tab === 'bank' ? 2 : 1;
            const list = this.allAccounts.filter(a => a.type === type);
            this.accountOptions = [{ id: null, name: '所有账户' }].concat(list);
        },
        onTabChange() {
            this.accountId = null;
            this.buildAccountOptions();
            if (this.accountOptions.length > 1) this.accountId = this.accountOptions[1].id;
            this.loadList();
        },
        loadList() {
            this.$api.funds.journal.list({
                accountId: this.accountId,
                p1: this.fmtPeriod(this.p1),
                p2: this.fmtPeriod(this.p2)
            }).then(({ data }) => {
                this.datas = (data.rows || []).map(d => Object.assign({ _checked: false }, d));
                this.initBalance = data.initBalance || 0;
                this.totalIncome = data.totalIncome || 0;
                this.totalExpense = data.totalExpense || 0;
            });
        },
        onIoTypeChange(id) {
            const t = this.ioTypeOptions.find(t => t.id === id);
            if (t && t.ioType) this.form.direction = t.ioType;
        },
        matchIoType() {
            if (!this.form.summary) return;
            this.$api.funds.ioType.match(this.form.summary).then(({ data }) => {
                if (data) {
                    this.form.ioTypeId = data.id;
                    this.form.direction = data.ioType;
                }
            });
        },
        add() {
            this.form = Object.assign({}, emptyForm, {
                journalDate: new Date(),
                accountId: this.accountId || (this.allAccounts[0] && this.allAccounts[0].id)
            });
            this.showForm = true;
        },
        edit(item) {
            const f = Object.assign({}, emptyForm, item);
            f.journalDate = item.journalDate ? new Date(item.journalDate) : new Date();
            this.form = f;
            this.showForm = true;
        },
        submit(keepOpen) {
            if (!this.$refs.form.valid().result) return;
            const payload = Object.assign({}, this.form);
            payload.journalDate = this.fmtDate(payload.journalDate);
            this.loading = true;
            this.$api.funds.journal[payload.id ? 'update' : 'save'](payload).then(() => {
                this.loading = false;
                this.loadList();
                this.$Message.success('保存成功');
                if (keepOpen) {
                    this.form = Object.assign({}, emptyForm, {
                        journalDate: new Date(),
                        accountId: payload.accountId
                    });
                } else {
                    this.showForm = false;
                }
            }).catch(() => { this.loading = false; });
        },
        remove(item) {
            this.$Confirm(`确认删除该笔日记账?`).then(() => {
                this.$api.funds.journal.delete(item.id).then(() => this.loadList());
            });
        },
        batchRemove() {
            const ids = this.checkedList.map(d => d.id);
            this.$Confirm(`确认删除选中的 ${ids.length} 笔记录?`).then(() => {
                Promise.all(ids.map(id => this.$api.funds.journal.delete(id))).then(() => this.loadList());
            });
        },
        generateVoucher() {
            const ids = this.checkedList.map(d => d.id);
            this.$api.funds.journal.generateVoucher(ids).then(({ msg }) => {
                this.$Message.success(msg || '已生成凭证');
                this.loadList();
            });
        },
        toggleAll() {
            const v = !this.checkAll;
            this.datas.forEach(d => { if (!d.voucherId) d._checked = v; });
        },
        exportCsv() {
            const head = ['日记账序号', '日期', '币别', '摘要', '收支类别', '收入(借方)', '支出(贷方)', '余额',
                '对方户名', '对方科目', '单据号', '备注'];
            const rows = this.datas.map(d => [
                d.seq, d.journalDate, d.currencyName, d.summary, d.ioTypeName,
                d.direction === 1 ? d.amount : '', d.direction === 2 ? d.amount : '', d.balance,
                d.counterparty, `${d.subjectCode || ''} ${d.subjectName || ''}`.trim(), d.billNo, d.remark
            ]);
            rows.push(['合计', '', '', '', '', this.totalIncome, this.totalExpense, this.endBalance, '', '', '', '']);
            const csv = [head].concat(rows).map(r => r.map(c => `"${c == null ? '' : c}"`).join(',')).join('\r\n');
            this.download(`日记账_${this.fmtPeriod(this.p1)}_${this.fmtPeriod(this.p2)}.csv`, '\ufeff' + csv);
        },
        download(name, content) {
            const blob = new Blob([content], { type: 'text/csv;charset=utf-8' });
            const a = document.createElement('a');
            a.href = URL.createObjectURL(blob);
            a.download = name;
            a.click();
            URL.revokeObjectURL(a.href);
        },
        printPage() { window.print(); },
        notOpen(name) { this.$Message.info(`${name}功能暂未开放`); }
    },
    mounted() {
        this.loadOptions();
    }
};
</script>

<style scoped lang="less">
    .filter-bar {
        display: flex;
        align-items: center;
        gap: 8px;
        flex-wrap: wrap;

        .label { margin-left: 6px; }
        .flex-spacer { flex: 1; }
    }

    .grid {
        width: 100%;
        border-collapse: collapse;
        margin-top: 10px;

        th, td {
            padding: 0 8px;
            border: 1px solid #e2e2e2;
            font-size: 12px;
            height: 32px;
            white-space: nowrap;
        }

        th {
            background-color: #f5f5f5;
            text-align: center;
            font-weight: bold;
            height: 35px;
        }

        tbody tr:nth-child(even) { background-color: #fafafa; }
        tbody tr:hover { background-color: #f0f6ff; }

        .init-row td { background-color: #fffbe6; font-weight: bold; }
        .total td { background-color: #f5f5f5; font-weight: bold; }
    }

    .actions span {
        margin-right: 8px;
        cursor: pointer;
        color: #3b91ff;
    }

    .text-hover { cursor: pointer; }
</style>
